import { solveChallenge, solveChallengeWorkers } from 'altcha-lib/v1'
import V1Worker from 'altcha-lib/v1/worker?worker'
import type { AxiosInstance } from 'axios'

interface AltchaChallenge {
  algorithm: string
  challenge: string
  maxnumber: number
  salt: string
  signature: string
}

const CONCURRENCY = Math.min(Math.max((navigator.hardwareConcurrency || 4) - 1, 1), 8)

async function solve(challenge: AltchaChallenge) {
  try {
    return await solveChallengeWorkers(
      () => new V1Worker(),
      CONCURRENCY,
      challenge.challenge,
      challenge.salt,
      challenge.algorithm,
      challenge.maxnumber,
    )
  } catch {
    return solveChallenge(challenge.challenge, challenge.salt, challenge.algorithm, challenge.maxnumber).promise
  }
}

export async function getAltchaToken(masterAxiosInstance: AxiosInstance): Promise<string> {
  const { data: challenge } = await masterAxiosInstance.get<AltchaChallenge>('altcha/challenge')

  const solution = await solve(challenge)

  if (!solution) {
    throw new Error('ALTCHA: Failed to solve challenge')
  }

  return btoa(
    JSON.stringify({
      algorithm: challenge.algorithm,
      challenge: challenge.challenge,
      number: solution.number,
      salt: challenge.salt,
      signature: challenge.signature,
      took: solution.took,
    }),
  )
}
